import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import { SessionRestoreGate } from '@/features/auth';
import { persistor, store } from '@/store';

export function StoreProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SessionRestoreGate>{children}</SessionRestoreGate>
      </PersistGate>
    </Provider>
  );
}
